(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crella-slideshow-texto-fijo"] && !Shopify.designMode) return;
  try {
    
  /**
   * CRELLA — Controlador de slideshow.
   *
   * 1. CORTE INSTANTANEO
   *    El slideshow de Horizon no anima con transform: hace
   *    scrollTo({ behavior: 'smooth' }). La duracion la define el navegador y no
   *    es configurable. En vez de reescribir el motor, se sobreescribe el metodo
   *    `select` de la instancia para forzar `animate: false`, que es la bandera
   *    que slideshow.js ya traduce a behavior: 'instant'.
   *
   * 2. AUTOPLAY PROPIO
   *    El autoplay nativo tiene tres problemas:
   *    a) pause() marca paused = true, pero resume() retorna temprano si
   *       paused es true. Como nada mas lo pone en false, la primera vez que
   *       la pestana pasa a segundo plano el autoplay queda muerto para
   *       siempre.
   *    b) Pausa con mouseenter sobre TODO el componente, no sobre la imagen.
   *    c) parseInt(attr) * 1000: solo acepta segundos enteros.
   *
   * 3. CICLOS LIMITADOS
   *    Con data-cycles > 0 la secuencia corre N vueltas completas y se detiene
   *    en el ultimo cuadro, en vez de girar para siempre. Formula:
   *    pasos = ciclos * cantidad_de_slides - 1, porque partimos en el slide 0.
   *    Opcionalmente vuelve a correr cuando la seccion reentra en pantalla.
   */
  class CrellaSlideshowController extends HTMLElement {
    connectedCallback() {
      this.attempts = 0;
      this.visible = true;
      this.steps = 0;
      this.finished = false;
      customElements.whenDefined('slideshow-component').then(() => this.apply());
    }

    disconnectedCallback() {
      this.stopTimer();
      if (this.io) {
        this.io.disconnect();
        this.io = null;
      }
    }

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    startTimer(target, interval, maxSteps, hoverPause) {
      this.stopTimer();
      this.timer = setInterval(() => {
        if (document.hidden) return;
        if (!this.visible) return;
        if (hoverPause && target.matches(':hover')) return;

        target.next();

        if (maxSteps > 0) {
          this.steps += 1;
          if (this.steps >= maxSteps) {
            this.finished = true;
            this.stopTimer();
          }
        }
      }, interval);
    }

    apply() {
      const id = this.getAttribute('for');
      const target = id ? document.getElementById(id) : null;
      const ready = target && typeof target.select === 'function' && typeof target.suspend === 'function';

      // El upgrade del custom element puede llegar unos frames despues.
      if (!ready) {
        if (this.attempts++ > 60) return;
        requestAnimationFrame(() => this.apply());
        return;
      }

      // ---- 1. Corte instantaneo ------------------------------------------
      if (this.dataset.instant === 'true' && target.dataset.crellaInstant !== 'true') {
        target.dataset.crellaInstant = 'true';
        const originalSelect = target.select.bind(target);
        target.select = (input, event, options = {}) =>
          originalSelect(input, event, Object.assign({}, options, { animate: false }));
      }

      // ---- 2. Autoplay propio --------------------------------------------
      const interval = parseInt(this.dataset.interval || '0', 10);
      if (interval <= 0 || target.dataset.crellaAutoplay === 'true') return;
      target.dataset.crellaAutoplay = 'true';

      // Referencias a los metodos del prototipo ANTES de neutralizarlos:
      // son las mismas funciones que se pasaron a addEventListener.
      const nativeSuspend = target.suspend;
      const nativeResume = target.resume;

      target.suspend();
      target.removeEventListener('mouseenter', nativeSuspend);
      target.removeEventListener('mouseleave', nativeResume);

      // Neutraliza el ciclo pause/resume/play nativo para que nada vuelva a
      // crear un setInterval paralelo ni deje el componente bloqueado.
      target.play = () => {};
      target.resume = () => {};
      target.pause = () => {};
      target.suspend = () => {};

      if (
        this.dataset.reducedMotion === 'true' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      // ---- 3. Ciclos limitados -------------------------------------------
      const slideCount = (target.slides && target.slides.length) || target.querySelectorAll('slideshow-slide').length;
      const cycles = parseInt(this.dataset.cycles || '0', 10);
      const maxSteps = cycles > 0 && slideCount > 1 ? cycles * slideCount - 1 : 0;
      const replay = this.dataset.replay === 'true';
      const hoverPause = this.dataset.hoverPause === 'true';

      // Observador propio: no dependemos del atributo [in-viewport] del tema.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              this.visible = entry.isIntersecting;

              // Vuelve a correr la secuencia desde el primer cuadro cuando la
              // seccion reentra en pantalla despues de haber terminado.
              if (entry.isIntersecting && this.finished && replay && maxSteps > 0) {
                this.finished = false;
                this.steps = 0;
                target.select(0);
                this.startTimer(target, interval, maxSteps, hoverPause);
              }
            }
          },
          { rootMargin: '100px' }
        );
        this.io.observe(target);
      }

      this.startTimer(target, interval, maxSteps, hoverPause);
    }
  }

  if (!customElements.get('crella-slideshow-controller')) {
    customElements.define('crella-slideshow-controller', CrellaSlideshowController);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crella-slideshow"] && !Shopify.designMode) return;
  try {
    
  /**
   * CRELLA — Controlador de slideshow.
   *
   * 1. CORTE INSTANTANEO
   *    El slideshow de Horizon no anima con transform: hace
   *    scrollTo({ behavior: 'smooth' }). La duracion la define el navegador y no
   *    es configurable. En vez de reescribir el motor, se sobreescribe el metodo
   *    `select` de la instancia para forzar `animate: false`, que es la bandera
   *    que slideshow.js ya traduce a behavior: 'instant'.
   *
   * 2. AUTOPLAY PROPIO
   *    El autoplay nativo tiene tres problemas:
   *    a) pause() marca paused = true, pero resume() retorna temprano si
   *       paused es true. Como nada mas lo pone en false, la primera vez que
   *       la pestana pasa a segundo plano el autoplay queda muerto para
   *       siempre.
   *    b) Pausa con mouseenter sobre TODO el componente, no sobre la imagen.
   *    c) parseInt(attr) * 1000: solo acepta segundos enteros.
   *
   * 3. CICLOS LIMITADOS
   *    Con data-cycles > 0 la secuencia corre N vueltas completas y se detiene
   *    en el ultimo cuadro, en vez de girar para siempre. Formula:
   *    pasos = ciclos * cantidad_de_slides - 1, porque partimos en el slide 0.
   *    Opcionalmente vuelve a correr cuando la seccion reentra en pantalla.
   */
  class CrellaSlideshowController extends HTMLElement {
    connectedCallback() {
      this.attempts = 0;
      this.visible = true;
      this.steps = 0;
      this.finished = false;
      customElements.whenDefined('slideshow-component').then(() => this.apply());
    }

    disconnectedCallback() {
      this.stopTimer();
      if (this.io) {
        this.io.disconnect();
        this.io = null;
      }
    }

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    startTimer(target, interval, maxSteps, hoverPause) {
      this.stopTimer();
      this.timer = setInterval(() => {
        if (document.hidden) return;
        if (!this.visible) return;
        if (hoverPause && target.matches(':hover')) return;

        target.next();

        if (maxSteps > 0) {
          this.steps += 1;
          if (this.steps >= maxSteps) {
            this.finished = true;
            this.stopTimer();
          }
        }
      }, interval);
    }

    apply() {
      const id = this.getAttribute('for');
      const target = id ? document.getElementById(id) : null;
      const ready = target && typeof target.select === 'function' && typeof target.suspend === 'function';

      // El upgrade del custom element puede llegar unos frames despues.
      if (!ready) {
        if (this.attempts++ > 60) return;
        requestAnimationFrame(() => this.apply());
        return;
      }

      // ---- 1. Corte instantaneo ------------------------------------------
      if (this.dataset.instant === 'true' && target.dataset.crellaInstant !== 'true') {
        target.dataset.crellaInstant = 'true';
        const originalSelect = target.select.bind(target);
        target.select = (input, event, options = {}) =>
          originalSelect(input, event, Object.assign({}, options, { animate: false }));
      }

      // ---- 2. Autoplay propio --------------------------------------------
      const interval = parseInt(this.dataset.interval || '0', 10);
      if (interval <= 0 || target.dataset.crellaAutoplay === 'true') return;
      target.dataset.crellaAutoplay = 'true';

      // Referencias a los metodos del prototipo ANTES de neutralizarlos:
      // son las mismas funciones que se pasaron a addEventListener.
      const nativeSuspend = target.suspend;
      const nativeResume = target.resume;

      target.suspend();
      target.removeEventListener('mouseenter', nativeSuspend);
      target.removeEventListener('mouseleave', nativeResume);

      // Neutraliza el ciclo pause/resume/play nativo para que nada vuelva a
      // crear un setInterval paralelo ni deje el componente bloqueado.
      target.play = () => {};
      target.resume = () => {};
      target.pause = () => {};
      target.suspend = () => {};

      if (
        this.dataset.reducedMotion === 'true' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      // ---- 3. Ciclos limitados -------------------------------------------
      const slideCount = (target.slides && target.slides.length) || target.querySelectorAll('slideshow-slide').length;
      const cycles = parseInt(this.dataset.cycles || '0', 10);
      const maxSteps = cycles > 0 && slideCount > 1 ? cycles * slideCount - 1 : 0;
      const replay = this.dataset.replay === 'true';
      const hoverPause = this.dataset.hoverPause === 'true';

      // Observador propio: no dependemos del atributo [in-viewport] del tema.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              this.visible = entry.isIntersecting;

              // Vuelve a correr la secuencia desde el primer cuadro cuando la
              // seccion reentra en pantalla despues de haber terminado.
              if (entry.isIntersecting && this.finished && replay && maxSteps > 0) {
                this.finished = false;
                this.steps = 0;
                target.select(0);
                this.startTimer(target, interval, maxSteps, hoverPause);
              }
            }
          },
          { rootMargin: '100px' }
        );
        this.io.observe(target);
      }

      this.startTimer(target, interval, maxSteps, hoverPause);
    }
  }

  if (!customElements.get('crella-slideshow-controller')) {
    customElements.define('crella-slideshow-controller', CrellaSlideshowController);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
